export enum RoleEnum {
  // ADM
  ADMIN_ACTIONS = 0,
  GERENCIAR_REGRAS = 2,
  PAPEL = 1,
  SOLAR = 4,
  USUARIO = 3,

  // Bussiness
  ATUACAO = 11,
  FOLHA = 12,
  FOLHA_SEND_NOTIFICATION = 13,
  LOTACAO = 14,
  MOVIMENTACAO = 15,
  PERIODO = 16,
  SUBSTITUICAO = 17,

  // People
  COLABORADOR = 22,
  DEFENSOR = 21,
  ESTAGIARIO = 23,
  PESSOA = 20,


  // Structure
  COMARCA = 30,
  CURSO = 31,
  DEFENSORIA = 32,
  DISTRITO = 33,
  FERIADO = 34,
  INSTITUICAO_ENSINO = 35,
  NUCLEO = 36,
  NUCLEO_MAX_ESTAGIARIOS = 37,
  PREDIO = 38,
  VARA = 39,
  CHANGELOG = 40,
}